import { type ReactNode } from 'react';
import {
  useProjectTableFilters,
  type ProjectTableFiltersContextValue,
} from '@/hooks/useProjectTableFilters';
import { createStrictTableFiltersContext } from '@/contexts/createStrictTableFiltersContext';

const [ProjectsTableFiltersContext, useProjectsTableFiltersContext] =
  createStrictTableFiltersContext<ProjectTableFiltersContextValue>('useProjectsTableFilters');

export const useProjectsTableFilters = useProjectsTableFiltersContext;

export function ProjectsTableFiltersProvider({ children }: { children: ReactNode }) {
  const value = useProjectTableFilters();
  return (
    <ProjectsTableFiltersContext.Provider value={value}>{children}</ProjectsTableFiltersContext.Provider>
  );
}
